// export const BASE_ROUTE = '/';
// export const LOGIN_ROUTE= '/login';
export const LOGIN_ROUTE= '/';
export const STORY_ROUTE ='/story';
export const STORY_LISTING_ROUTE ='/storyListing';
export const INVITE_SCREEN_ROUTE='/inviteScreen';
export const ADMIN_USER_SCREEN_ROUTE ='/adminUserScreen';
export const EDIT_STORY_SCREEN_ROUTE = '/editStory/:storyId' ;
export const ADD_COMPANY_ROUTE='/addCompany';
export const COMPANY_ROUTE='/company';
export const USER_LISTING_ROUTE='/userListing';
export const USER_ROUTE='/user';
export const ALL_STORY_ROUTE = '/allStories';
export const INVITE_USER = '/inviteUser'
export const EDIT_COMPANY = '/editCompany/:companyID';
export const REPORT = '/report';
export const INSIGHTS = '/storyInsights';
export const INSIGHTS_ID = '/insights/:storyID';
export const REEL_INSIGHTS = '/reelInsights';
export const STORY_PREVIEW='/story/preview/:origin/:companyID/:storyID';
// export const EDIT_STORY_SCREEN_ROUTE = '/' ;

export const HOME_ROUTE = '/home';

export const COMPANY_PURCHASES_ROUTE = '/companies/:centralCompanyId/purchases';

export const PURCHASE_STORIES_ROUTE = '/companies/:centralCompanyId/purchases/:purchaseId/stories';

export const PURCHASE_ADD_STORY_ROUTE = '/companies/:centralCompanyId/purchases/:purchaseId/stories/add';

export const PURCHASE_IMPORT_STORIES_ROUTE = '/companies/:centralCompanyId/purchases/:purchaseId/stories/import';
